import { PickByValue } from 'utility-types';

import { AttributeFacet } from '@mp/shared/facets/domain';

import { DrilldownFacetType, FacetResult } from '../models';

/**
 * Returns the key of `FacetResult` that the given `DrilldownFacetType` corresponds to.
 *
 * @param facetType The drilldown facet type.
 * @returns The key of `FacetResult`.
 */
export function getDrilldownFacetKey(facetType: DrilldownFacetType): keyof PickByValue<FacetResult, AttributeFacet> {
  switch (facetType) {
    case DrilldownFacetType.ArticleFeature:
      return 'articleFeatures';
    case DrilldownFacetType.EClassFeature:
      return 'eClassFeatures';
    case DrilldownFacetType.PharmaceuticalFeature:
      return 'pharmaceuticalFeatures';
    default:
      throw new Error(`Unsupported DrilldownFacetType: ${facetType}`);
  }
}
